
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(5(1(535|75|89)|(300|802|98)6|(03|47)77|0982|2769|4871|5808|8265|9524)|8(4(3(1|32|96)|138)|032[89]|8[26]75|3084|3952|583|6301)|6(4(364|60|78|816)|3314|5413|8166|9520)|2(074|1246|3816|7105)|4(8(475|718|862)|(206|318|542|734)2|1550|1653|2991|3065|4109|4230|6686)|3(8(444|674|837|905)|120|2016|6888|9428|9819)|1((104|290|52|557|650|661)3|0645|9702)|9((289|495|922)3|0839|4124|5750|7669|8145)|7(8(388|458|477|794)|0404|1725|1930|2536|2758|6957|7054))$/.test(chunkId);
},
rootOutputDir: "",

    };
}
